module.exports = __webpack_public_path__ + "static/media/ceremony_default.cc0ed367.svg";